<template>
    <MainContainer :container="!xs" background="lightGrey" :footer="false" :style="{ 'padding-bottom': '80px' }">

            <template slot="header">
                 <div class="bg-white bb b--light-gray">
                    <div class="container">
                    <SearchBar class="col-xs-12"/>
                    </div>
                </div>
            </template>
               
            <HugeSpinner v-if="loadingListingDetails"/>
            <div v-else>
                <div>
                    <div class="row">
                        <div :class="{'w-100' : xs, 'col-xs-12' : !xs}" class="col-md-7 col-lg-8 mt3 mt4-ns">
                            <ToolCard />
                        </div>
                        <div :class="{'w-100' : xs, 'col-xs-12' : !xs}" class="col-md-5 col-lg-4">
                            <PricingCard class="mt3 mt4-ns" :rates="listing.rates" :dailyRate="listing.dailyRate" />
                            <OwnerCard :owner="user" class="mt3 mt4-ns"/>
                        </div>

                    </div>
                    <div :class="{'w-100' : xs, 'col-xs-12' : !xs}" class="col-md-7 col-lg-8">
                        <SimilarToolsCard :similarListings="similarListings" class="mv3 mv4-ns"/>
                    </div> 
                </div>
                <ActionBar :fixed="true" :style="{ 'height': '80px' }">
                    <div class="container w-100">
                        <div class="flex items-center justify-end">
                            <div class="flex items-center">
                                <h6>{{listing.dailyRate | toCurrency}}</h6>
                                <div class="mh2"> / </div>
                                <div class="bodyCopy">Day</div>
                            </div>
                            <router-link class="no-underline w-50 w-25-ns ml3" :to="'/rental-details/' + listing.id">
                                <TooliabaButton >Rent this tool</TooliabaButton>
                            </router-link>
                        </div>
                    </div>
                </ActionBar>
            </div>
    </MainContainer>
</template>

<script>
import MainContainer from '@/components/layout/MainContainer.vue';
import StickyFooter from '@/components/global/StickyFooter.vue';
import ActionButtons from '@/components/global/ActionButtons.vue';
import SearchBar from '@/components/global/SearchBar.vue';
import ToolCard from '@/components/rent/listingDetail/ToolCard.vue';
import PricingCard from '@/components/rent/listingDetail/pricingCard/PricingCard.vue';
import OwnerCard from '@/components/rent/listingDetail/ownerCard/OwnerCard.vue';
import SimilarToolsCard from '@/components/rent/listingDetail/SimilarToolsCard.vue';
import ActionBar from '@/components/global/ActionBar.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';
import HugeSpinner from '@/components/controls/HugeSpinner.vue';
import { mapActions, mapState } from 'vuex';

export default {
    components: {
        MainContainer,
        StickyFooter,
        ActionButtons,
        SearchBar,
        ToolCard,
        PricingCard,
        SimilarToolsCard,
        OwnerCard,
        ActionBar,
        TooliabaButton,
        HugeSpinner
    },
    computed: {
        ...mapState('listingDetail', [
            'listing',
            'user',
            'similarListings',
            'loadingListingDetails'
        ]),
        xs() {
            return this.$mq === 'xs';
        }
    },
    methods: {
        ...mapActions('listingDetail', ['getListingDetail'])
    },
    watch: {
        $route() {
            this.getListingDetail(this.$route.params.id);
        }
    },
    created: function() {
        this.getListingDetail(this.$route.params.id);
    }
};
</script>
